// extracted by mini-css-extract-plugin
export var carrierIcon = "_wg-0";
export var carrierLogo = "_wg-1";
export var detailsSection = "_wg-2";